export default function getByteSize(size) {
  const byteUnits = ["KB", "MB", "GB", "TB"];
  for (let i = 0; i < byteUnits.length; i++) {
    if (size < 1024) return size.toFixed(1) + byteUnits[i];
    size = size / 1024;
  }
};